import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-switch",
  "use": "icon-switch-usage",
  "viewBox": "0 0 30.793 8.847",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30.793 8.847\" id=\"icon-switch\">\r\n  <path id=\"icon-switch_路径_22454\" data-name=\"路径 22454\" d=\"M157.092,305.812l-7.145-7.145-1.191,1.191,5.954,5.955H128v1.7h30.793l-1.7-1.7Z\" transform=\"translate(-128 -298.667)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol